<div class="mho-main" [class.noel]="family() === 'noel'">
    <mho-header #header (changeSidenavStatus)="sidenav.toggle()"></mho-header>

    @if (family() === 'noel') {
        <ul class="lightrope">
            @for (i of [].constructor(50); track $index) {
                <li></li>
            }
        </ul>
    }

    @if (family() === 'halloween') {
        <div class="web-spider">
            <div class="web">
                <img [ngSrc]="'img/halloween/spider-web.png'" height="1000" width="1000">
            </div>
            <div class="spider">
                <span class="eye left"></span>
                <span class="eye right"></span>
                <span class="leg left"></span>
                <span class="leg left"></span>
                <span class="leg left"></span>
                <span class="leg left"></span>
                <span class="leg right"></span>
                <span class="leg right"></span>
                <span class="leg right"></span>
                <span class="leg right"></span>
            </div>
        </div>
    }

    <mat-sidenav-container #sidenavContainer class="mho-container">
        <mat-sidenav #sidenav [mode]="is_gt_xs() ? 'side' : 'over'" [opened]="is_gt_xs()">
            <mho-menu [sidenavContainer]="sidenavContainer"></mho-menu>
        </mat-sidenav>
        <mat-sidenav-content class="mho-content">
            <mat-card>
                @if (ready()) {
                    <router-outlet></router-outlet>
                }
            </mat-card>
        </mat-sidenav-content>
    </mat-sidenav-container>

    @if (is_loading()) {
        <div class="mho-loading">
            @switch (family()) {
                @case ('halloween') {
                    <div class="ghost-container">
                        <div class="ghost animate-hover">
                            <svg class="body" viewBox="0 0 250 300" aria-hidden="true">
                                <path
                                    d="M0 150 A125 150 0 0 1 250 150 V202 L274.9 310.6 C278.9 328.1 266.8 337 250 330 A80 150 0 0 0 170 330 A80 150 0 0 1 130 350 H120 A80 150 0 0 1 80 330 A80 150 0 0 0 0 330 C-18.5 336.6 -30.3 327.4 -25.9 309.8 L0 206.4 Z"/>
                            </svg>
                            <div class="face">
                                <div class="eye eye-left"></div>
                                <div class="eye eye-right"></div>
                                <div class="mouth animate-smile"></div>
                            </div>
                        </div>
                    </div>
                }
                @default {
                    <mat-spinner [color]="'accent'"></mat-spinner>
                }
            }
        </div>
    }
</div>
